// src/pages/RatesPage.js

import React, { useState, useEffect } from 'react';
import axiosInstance from "../api/axiosInstance";
import { useAuth } from "../context/AuthContext";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const RatesPage = () => {
  const { authData } = useAuth();
  const [discountedPrices, setDiscountedPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Retrieve hotelId from authData; adjust property name if different.
  const hotelId = authData?.hotelId;

  useEffect(() => {
    if (!hotelId) {
      setError("Hotel ID is not available.");
      setLoading(false);
      return;
    }

    const fetchDiscountedPrices = async () => {
      try {
        const response = await axiosInstance.get(`/Price/discounted/hotel/${hotelId}`);
        setDiscountedPrices(response.data);
      } catch (err) {
        setError(err.response ? err.response.data.Message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDiscountedPrices();
  }, [hotelId]);

  return (
    <div>
      <Breadcrumb />
      <h1>Room Rates</h1>
      <p>This is the Rates page where you can view the discounted room rates for your hotel.</p>

      {loading ? (
        <p>Loading discounted rates...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        <div className="discounted-room-rates">
          <h2>Discounted Room Rates</h2>
          <table>
            <thead>
              <tr>
                <th>Room Type</th>
                <th>Standard Rate (per night)</th>
                <th>Discounted Rate</th>
              </tr>
            </thead>
            <tbody>
              {discountedPrices.map((price, index) => (
                <tr key={index}>
                  <td>{price.roomType}</td>
                  <td>{price.currency}{price.standardRate}</td>
                  <td>{price.currency}{price.discountedRate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RatesPage;
